import { type PayloadLoadSlide, loadSlide, loadSlideError } from './actions';
import {
  type ExtractPayload,
  persistentReducedStream,
  reducer,
} from '@ardoq/rxbeach';
import { APISlideAttributes } from '@ardoq/api-types';

export type ViewPaneState = {
  slideError: any;
  loadedSlide: APISlideAttributes | null;
};

const defaultState: ViewPaneState = {
  slideError: undefined,
  loadedSlide: null,
};

const handleLoadSlide = (
  currentState: ViewPaneState,
  { loadedSlide }: PayloadLoadSlide
): ViewPaneState => ({
  ...currentState,
  slideError: undefined,
  loadedSlide,
});

const handleLoadSlideError = (
  currentState: ViewPaneState,
  { error }: ExtractPayload<typeof loadSlideError>
): ViewPaneState => ({
  ...currentState,
  slideError: error,
  loadedSlide: null,
});

const reducers = [
  reducer(loadSlide, handleLoadSlide),
  reducer(loadSlideError, handleLoadSlideError),
];

const viewPane$ = persistentReducedStream('viewPane$', defaultState, reducers);

export { viewPane$ };
